module.exports = __webpack_public_path__ + "static/img/NI@3x.8baccf9c.jpg";